export default __webpack_public_path__ + "static/media/refresh.7858c6c1.svg";